<template>
  <div class="admin-layout">
    <Sidebar class="sidebar-fixed" />

    <div class="main-content container-fluid pt-4">
      <div class="mb-2">
  <h4 class="fw-bold text-center">Administradores</h4>
</div>

<!-- Botón alineado a la derecha -->
<div class="d-flex justify-content-end mb-4">
  <button class="btn btn-primary" @click="abrirModalAgregar">
    <i class="fas fa-user-plus"></i> Agregar administrador
  </button>
</div>

      <div v-if="administradores.length === 0" class="text-muted">No hay administradores registrados.</div>

      <!-- Vista en tarjetas tipo CRM -->
      <div class="row g-4">
        <div
          v-for="admin in administradores"
          :key="admin.id"
          class="col-12 col-sm-6 col-md-4 col-lg-3"
        >
          <div class="admin-card card h-100 shadow-sm">
            <div class="card-body text-center">
              <img
                :src="'http://localhost:3000/uploads/' + admin.foto_perfil"
                class="rounded-circle mb-3"
                style="width: 80px; height: 80px; object-fit: cover;"
                alt="Foto perfil"
              />
              <h6 class="fw-bold mb-1">{{ admin.nombre_completo }}</h6>
              <small class="text-muted d-block mb-1">{{ admin.usuario }}</small>
              <p class="text-muted small mb-1">{{ admin.email }}</p>
              <span class="badge bg-secondary">{{ admin.rol_nombre }}</span>
            </div>
            <div class="card-footer d-flex justify-content-center gap-2">
              <button class="btn btn-sm btn-outline-primary" @click="editarAdministrador(admin)">
                <i class="fas fa-edit"></i>
              </button>
              <button class="btn btn-sm btn-outline-danger" @click="eliminarAdministrador(admin.id)">
                <i class="fas fa-trash"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Modal -->
      <div v-if="modalVisible" class="modal-backdrop" @keydown.esc="cerrarModal" tabindex="0">
        <div class="modal-content-custom" role="dialog" aria-modal="true" aria-labelledby="modalTitle">
          <div class="modal-header">
            <h5 id="modalTitle">{{ modoEdicion ? "Editar" : "Registrar" }} administrador</h5>
            <button class="btn-close" @click="cerrarModal" aria-label="Cerrar modal">
              &times;
            </button>
          </div>

          <div class="modal-body">
            <form
              @submit.prevent="registrarAdministrador"
              enctype="multipart/form-data"
              ref="formModal"
            >
              <div class="mb-2">
                <label class="form-label">Usuario</label>
                <input
                  type="text"
                  v-model="form.usuario"
                  class="form-control"
                  :readonly="modoEdicion"
                  required
                />
              </div>

              <div class="mb-2" v-if="!modoEdicion">
                <label class="form-label">Contraseña</label>
                <input
                  type="password"
                  v-model="form.password"
                  class="form-control"
                  required
                />
              </div>

              <!-- Nueva contraseña para edición con mostrar/ocultar -->
              <div class="mb-2" v-if="modoEdicion">
                <label class="form-label">Nueva Contraseña</label>
                <div class="input-group">
                  <input
                    :type="mostrarPassword ? 'text' : 'password'"
                    v-model="form.password"
                    class="form-control"
                    placeholder="Dejar vacío para no cambiar"
                  />
                  <button
                    type="button"
                    class="btn btn-outline-secondary"
                    @click="mostrarPassword = !mostrarPassword"
                    :aria-label="mostrarPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'"
                  >
                    <i :class="mostrarPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
                  </button>
                </div>
              </div>

              <div class="mb-2">
                <label class="form-label">Nombre completo</label>
                <input
                  type="text"
                  v-model="form.nombre_completo"
                  class="form-control"
                  required
                />
              </div>

              <div class="mb-2">
                <label class="form-label">Email</label>
                <input type="email" v-model="form.email" class="form-control" />
              </div>

              <div class="mb-2">
                <label class="form-label">Rol</label>
                <select v-model="form.rol_id" class="form-select" required @change="cargarPermisosPorRol">
                  <option disabled value="">Selecciona un rol</option>
                  <option v-for="rol in roles" :key="rol.id" :value="rol.id">
                    {{ rol.nombre }}
                  </option>
                </select>
              </div>

              <div class="mb-2">
                <label class="form-label">Permisos</label>
                <div v-for="permiso in permisos" :key="permiso.id" class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    :value="permiso.id"
                    v-model="form.permisos"
                    :id="'permiso-' + permiso.id"
                  />
                  <label class="form-check-label" :for="'permiso-' + permiso.id">
                    {{ permiso.nombre }}
                  </label>
                </div>
              </div>

              <div class="mb-2">
                <label class="form-label">Foto de perfil</label>
                <input type="file" class="form-control" @change="handleFile" />
              </div>
            </form>
          </div>

          <div class="modal-footer">
            <button
              type="submit"
              class="btn btn-success w-100"
              @click="$refs.formModal.requestSubmit()"
            >
              {{ modoEdicion ? "Guardar cambios" : "Registrar Administrador" }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Sidebar from "@/components/Sidebar.vue";
import Swal from "sweetalert2";

export default {
  components: { Sidebar },
  data() {
    return {
      administradores: [],
      roles: [],
      permisos: [],
      form: {
        id: null,
        usuario: "",
        password: "",
        nombre_completo: "",
        email: "",
        rol_id: "",
        permisos: [],
      },
      fotoPerfil: null,
      mensaje: "",
      modalVisible: false,
      modoEdicion: false,
      mostrarPassword: false,
    };
  },
  created() {
    this.obtenerRoles();
    this.obtenerPermisos();
    this.obtenerAdministradores();
  },
  methods: {
    async obtenerRoles() {
      const res = await axios.get("http://localhost:3000/api/roles");
      this.roles = res.data;
    },
    async obtenerPermisos() {
      const res = await axios.get("http://localhost:3000/api/permisos");
      this.permisos = res.data;
    },
    async obtenerAdministradores() {
      const res = await axios.get("http://localhost:3000/api/administradores");
      this.administradores = res.data;
    },
    handleFile(e) {
      this.fotoPerfil = e.target.files[0];
    },
    abrirModalAgregar() {
      this.resetForm();
      this.modalVisible = true;
      this.modoEdicion = false;
      this.mostrarPassword = false;
    },
    cerrarModal() {
      this.modalVisible = false;
      this.mostrarPassword = false;
    },
    editarAdministrador(admin) {
      this.modalVisible = true;
      this.modoEdicion = true;
      this.mostrarPassword = false;
      this.form = {
        id: admin.id,
        usuario: admin.usuario,
        password: "",
        nombre_completo: admin.nombre_completo,
        email: admin.email,
        rol_id: admin.rol_id,
        permisos: admin.permisos ? admin.permisos.map((p) => p.id) : [],
      };
      this.fotoPerfil = null;
    },
    async eliminarAdministrador(id) {
      const result = await Swal.fire({
        title: "¿Estás seguro?",
        text: "¡No podrás revertir esto!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Sí, eliminar",
        cancelButtonText: "Cancelar",
      });

      if (result.isConfirmed) {
        try {
          await axios.delete(`http://localhost:3000/api/administradores/${id}`);
          Swal.fire("Eliminado", "El administrador fue eliminado.", "success");
          this.obtenerAdministradores();
        } catch (error) {
          Swal.fire("Error", "No se pudo eliminar el administrador.", "error");
          console.error(error);
        }
      }
    },
    async cargarPermisosPorRol() {
  if (!this.form.rol_id) return;
  try {
    const res = await axios.get(`http://localhost:3000/api/roles/${this.form.rol_id}/permisos`);
    const permisosBase = res.data;

    // Si no está en modo edición, asigna los permisos base directamente
    if (!this.modoEdicion) {
      this.form.permisos = permisosBase.map(p => p.id);
    } else {
      // Si está en modo edición, conserva los permisos seleccionados
      const combinados = new Set([...this.form.permisos, ...permisosBase.map(p => p.id)]);
      this.form.permisos = Array.from(combinados);
    }
  } catch (error) {
    console.error("Error al cargar permisos por rol", error);
  }
},

    async registrarAdministrador() {
  try {
    const formData = new FormData();
    formData.append("usuario", this.form.usuario);

    // ✅ manejo de contraseña según modo
    if (!this.modoEdicion) {
      formData.append("password", this.form.password);
    } else if (this.form.password.trim() !== "") {
      formData.append("nueva_password", this.form.password);
    }

    formData.append("nombre_completo", this.form.nombre_completo);
    formData.append("email", this.form.email);
    formData.append("rol_id", this.form.rol_id);
    this.form.permisos.forEach((id) => formData.append("permisos[]", id));
    if (this.fotoPerfil) formData.append("foto_perfil", this.fotoPerfil);

    const token = localStorage.getItem("token");

    const url = this.modoEdicion
  ? `http://localhost:3000/api/administradores/${this.form.id}/actualizar`
  : `http://localhost:3000/api/administradores/registrar`;

    await axios.post(url, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });

    this.mensaje = this.modoEdicion
      ? "Administrador actualizado correctamente."
      : "Administrador registrado correctamente.";

    Swal.fire("Éxito", this.mensaje, "success");

    this.obtenerAdministradores();
    this.cerrarModal();
  } catch (error) {
    console.error(error);
    this.mensaje =
      error.response?.data?.mensaje || "Error al guardar el administrador";
    Swal.fire("Error", this.mensaje, "error");
  }
},

    resetForm() {
      this.form = {
        id: null,
        usuario: "",
        password: "",
        nombre_completo: "",
        email: "",
        rol_id: "",
        permisos: [],
      };
      this.fotoPerfil = null;
      this.mensaje = "";
      this.mostrarPassword = false;
    },
  },
};
</script>

<style scoped>
.admin-layout {
  display: flex;
  background-color: #e9ecf1; /* ⬅ AÑADIDO: mismo fondo para toda la sección */
  min-height: 100vh;
}

.sidebar-fixed {
  position: fixed;
  width: 250px;
  height: 100vh;
  background-color: #343a40;
  color: white;
  overflow-y: auto;
  z-index: 1000;
}

.main-content {
  margin-left: 250px;
  padding: 2rem;
  width: 100%;
  background-color: #e9ecf1; /* ⬅ Fondo más gris claro */
}

/* Tarjeta */
.admin-card {
  border: none;
  border-radius: 1rem;
  background-color: #ffffff;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
}

.admin-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
}

.admin-card .card-body {
  padding: 1.5rem;
}

/* Foto de perfil más grande */
.admin-card .card-body img {
  width: 220px;
  height: 220px;
  object-fit: cover;
}

/* Footer de la tarjeta */
.admin-card .card-footer {
  background-color: #f8f9fc;
  border-top: 1px solid #eaeaea;
  padding: 0.75rem;
  border-bottom-left-radius: 1rem;
  border-bottom-right-radius: 1rem;
}

/* Badge de rol */
.badge.bg-secondary {
  background-color: #6c63ff;
  color: white;
  font-size: 0.75rem;
  padding: 0.4em 0.6em;
  border-radius: 0.5rem;
}

/* Modal */
.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
  padding: 1rem;
}

.modal-content-custom {
  background: white;
  border-radius: 10px;
  width: 100%;
  max-width: 600px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.modal-header {
  padding: 1rem;
  border-bottom: 1px solid #dee2e6;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f1f3f5;
}

.modal-body {
  padding: 1rem;
  overflow-y: auto;
  flex: 1;
}

.modal-footer {
  padding: 1rem;
  border-top: 1px solid #dee2e6;
  background-color: #f1f3f5;
}

.btn-close {
  background: none;
  border: none;
  font-size: 1.5rem;
  font-weight: bold;
  cursor: pointer;
  line-height: 1;
  color: #000;
}

.btn-close:hover {
  color: #dc3545;
}

@media (max-width: 768px) {
  .sidebar-fixed {
    position: static;
    width: 100%;
    height: auto;
  }

  .main-content {
    margin-left: 0;
    padding: 1rem;
  }

  .modal-content-custom {
    max-height: 95vh;
  }
}

</style>
